/* AutoKeys Theme JS */

// ── CART DRAWER ──
const cartDrawer = document.getElementById('cartDrawer');
const cartOverlay = document.getElementById('cartOverlay');
const cartToggle = document.getElementById('cartToggle');
const cartClose = document.getElementById('cartClose');

function openCart() {
  cartDrawer?.classList.add('open');
  cartOverlay?.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCart() {
  cartDrawer?.classList.remove('open');
  cartOverlay?.classList.remove('open');
  document.body.style.overflow = '';
}

cartToggle?.addEventListener('click', openCart);
cartClose?.addEventListener('click', closeCart);
cartOverlay?.addEventListener('click', closeCart);

// ── ADD TO CART ──
async function addToCart(variantId, quantity = 1) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await refreshCart();
    openCart();
  } catch (err) {
    console.error('Add to cart error:', err);
  }
}

// ── REFRESH CART DRAWER ──
async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Update count badge
    document.querySelectorAll('#cartCount').forEach(el => {
      el.textContent = cart.item_count;
    });

    // Update drawer items
    const container = document.getElementById('cartItemsContainer');
    if (!container) return;

    if (cart.item_count === 0) {
      container.innerHTML = '<div class="cart-empty">YOUR CART IS EMPTY</div>';
      return;
    }

    container.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item-img">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
        </div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.product_title}</div>
          <div class="cart-item-variant">${item.variant_title !== 'Default Title' ? item.variant_title.toUpperCase() : ''}</div>
          <div class="cart-item-qty">
            <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
          </div>
        </div>
        <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
      </div>
    `).join('');

    // Update subtotal
    const subtotalEl = document.querySelector('.cart-subtotal-price');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  } catch (err) {
    console.error('Cart refresh error:', err);
  }
}

async function changeQty(key, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  await refreshCart();
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ── BIND ADD TO CART BUTTONS ──
document.addEventListener('click', e => {
  const btn = e.target.closest('.add-to-cart-btn, .quick-add-btn');
  if (!btn) return;
  const variantId = btn.dataset.variantId || btn.dataset.productId;
  if (variantId) {
    e.preventDefault();
    addToCart(variantId);
  }
});

// ── FILTER BUTTONS ──
document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  });
});

// ── KEYBOARD CLOSE ──
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closeCart();
});

// Init on load
refreshCart();
